<template>
  <div class="pa-4">
    <v-card class="mt-2 py-2">
      <v-form ref="orderform" id="orderform" v-model="valid" lazy-validation class="new-compact-form">
      <v-toolbar flat>
          <v-toolbar-title>{{$route.name}}</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <!-- <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>                 -->
          <v-spacer></v-spacer>
          <v-btn color="grey" dark class="mb-2 mr-2" @click="$router.push('/requestplanningprod/001')" small>
              <v-icon small>mdi-arrow-left</v-icon>
              Back
          </v-btn>

      </v-toolbar>    
      <div class="mt-3">
          <v-row class="mx-5 py-0" align="center">
            <v-col cols="2">Group</v-col>
            <v-col cols="4"><v-select :items="groups" item-text="description" return-object v-model="selectedGroup" outlined dense hide-details="auto" class="compact-form" :disabled="order.status==1" @change="changeCategory" :rules="reqRule"></v-select></v-col>
            <v-col cols="2">Remarks</v-col>
            <v-col cols="4"><v-text-field v-model="order.remarks" outlined dense hide-details="auto" class="compact-form" :disabled="order.status==1"></v-text-field></v-col>
          </v-row>
          <v-row class="mx-5" align="center">
            <v-col cols="2">Hari Kirim</v-col>
            <v-col cols="4">
              <v-menu v-model="dateDelivMenu" :close-on-content-click="true" :nudge-right="40" transition="scale-transition" offset-y min-width="auto" :disabled="!this.selectedGroup || order.status==1">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="order.delivery_date" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details="auto" dense outlined class="compact-form" :rules="reqRule"></v-text-field>
                </template>
                <v-date-picker v-model="order.delivery_date" @change="setDateExpired" :min="today"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="2">Koordinator</v-col>
            <v-col cols="4"><v-select :items="coordinators" item-text="name" item-value="code" v-model="order.coordinator_code" outlined dense hide-details="auto" class="compact-form" :disabled="order.status==1"></v-select></v-col>
          </v-row>
          <v-row class="mx-5" align="center">
            <template v-if="showExpiredDate">
              <v-col cols="2">Tanggal Expired</v-col>
              <v-col cols="4">
                <v-menu v-model="dateExpMenu" :close-on-content-click="true" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="order.expired_date" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details="auto" dense outlined class="compact-form" :rules="reqRule"></v-text-field>
                  </template>
                  <v-date-picker v-model="order.expired_date"></v-date-picker>
                </v-menu>

              </v-col>
            </template>
            <v-spacer></v-spacer>
            <v-col cols="4">
              <v-file-input outlined dense label="Upload CSV" @change="onFileChange" prepend-icon="mdi-upload" class="compact-form" hide-details="auto" v-if="order.status==0" :disabled="order.delivery_date===null"></v-file-input>
            </v-col>
          </v-row>
          <v-row class="mx-5" align="center">
            <v-col cols="2">Volume</v-col>
            <v-col cols="4">
              <v-select outlined dense hide-details="auto" class="compact-form" :items="bottles" item-value="code" item-text="description" v-model="selectedBottle" @change="onBotolChange" />
            </v-col>
            <!-- <v-spacer></v-spacer> -->
            <v-col cols="2">Additional Order</v-col>
            <v-col cols="4">
              <v-checkbox v-model="order.is_additional" dense></v-checkbox>
            </v-col>
          <v-col cols="2">Total Adjustment</v-col>
          <v-col cols="4">
            <v-text-field suffix="botol" type="number" v-model="totalAdjustment" outlined dense hide-details="auto" class="compact-form" :disabled="order.status==1 && profile.role_code!='SUP'"
            @wheel="$event.target.blur()">
            </v-text-field>
          </v-col>
        </v-row>
        <v-card outlined class="ma-3 mt-5" width="800px">
          <v-simple-table fixed-header fixed-footer height="350px">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Code</th>
                  <th class="text-left">Volume</th>
                  <th class="text-left">Variant</th>
                  <th class="text-left">Total</th>
                  <th class="text-left">Adjustment</th>
                  <th class="text-left">Aktual</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, vidx) in filteredOrderDetails" :key="vidx">
                  <td>{{item.variant.code}}</td>
                  <td>{{item.variant.size}} ml</td>
                  <td>{{item.variant.name}}</td>
                  <td>{{item.qty_initial}}</td>
                  <td>
                    <v-text-field type="number" dense outlined v-model="item.qty_adjustment" @input="calculateActualQuantity(item)" hide-details class="compact-form centered-input" style="width:100px" :disabled="order.status==1 && profile.role_code!='SUP'" @wheel="$event.target.blur()"></v-text-field>
                  </td>
                  <td>
                    <v-text-field type="number" dense outlined v-model="item.qty_ordered" hide-details class="compact-form centered-input" style="width:100px" :disabled="true" @wheel="$event.target.blur()"></v-text-field>
                  </td>
                </tr>

              </tbody>
              <tfoot>
                <tr>
                  <th class="text-center" colspan="3">TOTAL</th>
                  <th class="text-left">{{ calculatedTotalInitial }}</th>
                  <th class="text-left">{{ calculatedTotalAdjustment }}</th>
                  <th class="text-left">{{ calculatedTotalActual }}</th>
                </tr>
              </tfoot>

            </template>

          </v-simple-table>  
        </v-card>         
      </div>    
      <v-card-actions class="pr-4">
        <v-spacer></v-spacer>
        <v-btn depressed color="primary" @click="saveOrder" v-if="order.status==0 || profile.role_code=='SUP'">Save</v-btn>
      </v-card-actions> 
      </v-form>
    </v-card>
    <v-snackbar top v-model="saved" color="green">Data berhasil tersimpan!</v-snackbar>
    <v-snackbar top v-model="saveError" color="red accent-2">Data gagal tersimpan! Mohon pastikan data yang akan disimpan sudah sesuai.</v-snackbar>
    <v-overlay :value="onProgress" z-index="999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>        

  </div>
</template>

<script>
// import RequestProd from '../components/RequestProd.vue'
// import { VueCsvImport } from 'vue-csv-import';
import moment from 'moment'

export default {
  // components: { RequestProd },
  data() {
    return {
      reqRule: [v => !!v || 'Harus diisi!'],
      valid: true,
      saved: false,
      saveError: false,
      groups: null,
      selectedGroup: null,
      order: {
        order_batch: "",
        order_id: "",
        production_date: null,
        delivery_date: null,
        expired_date: null,
        coordinator_code: null,
        remarks: "",
        status: 0,
        order_category: "",
        order_details:[]
      },
      dateProdMenu: false,
      dateDelivMenu: false,
      dateExpMenu: false,
      variants: null,
      onProgress: false,
      showExpiredDate: true,
      coordinators: null,
      handleInput: 0,
      totalAdjustment: 0,
      filteredBotols: [],
      selectedBottle: 'all',
      filteredOrderDetails: [],
      bottles: [],
    }
  },
  computed: {
    today(){
      return moment().format("YYYY-MM-DD");
    },
    profile () {
      return this.$store.state.profile
    },
    calculatedTotalInitial() {
      return this.order.order_details.reduce((sum, item) => {
        if (this.selectedBottle === 'all' || item.variant.size === this.selectedBottle) {
          return sum + Number(item.qty_initial);
        }
        return sum;
      }, 0);
    },

    calculatedTotalAdjustment() {
      return this.order.order_details.reduce((sum, item) => {
        if (this.selectedBottle === 'all' || item.variant.size === this.selectedBottle) {
          return sum + Number(item.qty_adjustment);
        }
        return sum;
      }, 0);
      
    },
    calculatedTotalActual() {
      return this.order.order_details.reduce((sum, item) => {
        if (this.selectedBottle === 'all' || item.variant.size === this.selectedBottle) {
          return sum + Number(item.qty_ordered);
        }
        return sum;
      }, 0);
    },
  },
  filters: {
      sdate: function (date) {
          return moment(date).format('ddd D/MM');
      }
  },
  async created() {
    this.order.order_batch = this.$route.params.batch
    this.groups = (await this.$store.dispatch('ordercategory/getObjs')).data.data
    this.variants = (await this.$store.dispatch('variant/getObjs')).data.data
    this.coordinators = (await this.$store.dispatch('coordinator/getObjs')).data.data
    this.getBottles()
    const order_id = this.$route.params.order_id
    if (order_id!='new') {
      await this.loadOrder(order_id)
    }
    this.onBotolChange();
  },
  watch: {
  totalAdjustment(val) {
    this.order.order_details.forEach(element => {
      if (this.selectedBottle === 'all' || element.variant.size === this.selectedBottle) {
        element.qty_adjustment = Math.round(
          Number(val) * (Number(element.qty_initial) / this.calculatedTotalInitial)
        );
        element.qty_ordered = Number(element.qty_initial) + Number(element.qty_adjustment);
      }
    });
  }

  },
  methods: {
    getBottles() {
        let dataMiscCodes = this.$store.state.misccode.objs;
        this.bottles = dataMiscCodes.filter((i => i.type.includes('Botol')))
            .sort((a,b) => {
                return parseInt(a.code) - parseInt(b.code)
            });
        this.bottles.unshift({code: 'all', description: 'All'})
    },

    changeCategory(ev) {
      this.showExpiredDate = ev.plus_expired
    },
    calculateActualQuantity(item) {
      item.qty_ordered = Number(item.qty_initial) + Number(item.qty_adjustment)
    },
    async loadOrder(order_id) {
      const order = (await this.$store.dispatch('getObjs', {apidomain:'orders?fields[order_id]=', parameter:order_id})).data.data[0]
      order.order_details = order.details
      delete order.details
      this.order = JSON.parse(JSON.stringify(order))
      
      this.selectedGroup = this.groups.find(el => this.order.order_category == el.code)
      this.showExpiredDate = this.selectedGroup.plus_expired
      this.order.order_details.forEach(element => {
        var variant = this.variants.find(el => el.code === element.variant_code)
        element.variant = variant
        element.QTY = element.qty_ordered
        element.qty_adjustment = element.qty_adjustment || 0
        element.qty_initial = element.qty_ordered - element.qty_adjustment
        this.cleanObj(element)
      });
      this.order.order_details.sort((a, b) => {
        const sizeA = parseFloat(a.variant.size);
        const sizeB = parseFloat(b.variant.size);

        if (sizeA !== sizeB) {
          return sizeA - sizeB;
        }

        return a.variant.sort_no - b.variant.sort_no;
      });

    },
    async onBotolChange() {
      if (this.selectedBottle == 'all') {
        this.filteredOrderDetails = this.order.order_details
      } else {
        this.filteredOrderDetails = this.order.order_details.filter(element => element.variant.size == this.selectedBottle);
      }
    },
    async generateOrderID() {
      // Generate Order ID
      let url = this.$store.state.config.apiHost + "others/getordercount"
      let lastId = (await this.$axios.get(url, {headers:{'Authorization': 'Bearer '+ this.$store.state.token, 'Content-Type': 'application/json'}})).data.total
      let order_id = (lastId==null)? 10001 : Number(lastId) + 1
      return order_id
    },
    async saveOrder() {
      await this.$refs.orderform.validate();
      if (!this.order.order_details.length) {
        this.valid = false
        this.$store.commit('setSnackbar', {saveError: true, errorMessage: "Order line tidak boleh kosong!"})        
      }
      if (!this.valid) return;

      this.onProgress = true
      const order_id = this.$route.params.order_id
      if (order_id!='new') {
        await this.$store.dispatch('order/deleteObj', order_id)
      }
      else {
        this.order.delivery_date_initial = this.order.delivery_date
      }
      this.order.order_category = this.selectedGroup.code
      this.order.order_id = await this.generateOrderID()
      const docs = await this.$store.dispatch('order/postObj', {orders:[this.order]})
      
      if (docs.status==200 || docs.status==201) {
        this.$router.go(-1)
        this.saved = true
      }
      else this.saveError = true

      this.onProgress = false
    },
    setDates() {
      this.order.delivery_date = moment(this.order.production_date).add(this.selectedGroup.plus_delivery, 'd').format("YYYY-MM-DD")
      this.order.expired_date = moment(this.order.delivery_date).add(this.selectedGroup.plus_expired, 'd').format("YYYY-MM-DD")
    },
    setDateExpired() {
      this.order.expired_date = moment(this.order.delivery_date).add(this.selectedGroup.plus_expired, 'd').format("YYYY-MM-DD")
    },
    onClear() {
      this.$set(this.order, 'order_details', [])
    },
    async onFileChange(e) {
      if (e==null) { // on clear text
        return this.onClear()
      }
      if (e.name.substring(0, 10)!=this.order.delivery_date) {
        return this.$store.commit('setSnackbar', {saveError: true, errorMessage: "Nama file tidak sesuai dengan Hari Kirim!"})
      }
      this.onClear();
      let input = await this.getCsvFile(e)
      let importedItems = []
      this.order.order_details = []
      const importedItemsTemp = this.csvToJson(input)
      importedItems = importedItemsTemp.filter(el => {
        return (el.KODE_PRODUK !== null && el.QTY != 0)
      })
      importedItems.forEach(element => {
        var variant = this.variants.find(el => el.code === element.KODE_PRODUK)
        element.variant = variant
        this.order.order_details.push({
          variant_code: element.KODE_PRODUK,
          type: 'ALL',
          qty_ordered: element.QTY,
          variant: variant,
          qty_initial: element.QTY,
          qty_adjustment: 0
        })
      });
      importedItems.sort((a,b) => parseFloat(a.variant.size) - parseFloat(b.variant.size))
      this.onBotolChange();
    },
    getCsvFile(file) {
      return new Promise((resolve, reject) => {
          var reader = new FileReader();
          reader.readAsText(file);
          reader.onload = function () {
              resolve(reader.result);
          };
          reader.onerror = function (error) {
              reject('Error: ', error);
          };
      })      
    },
    csvToJson (text, headers, quoteChar = '"', delimiter = ',') {
      const regex = new RegExp(`\\s*(${quoteChar})?(.*?)\\1\\s*(?:${delimiter}|$)`, 'gs');

      const match = line => [...line.matchAll(regex)]
        .map(m => m[2])  // we only want the second capture group
        .slice(0, -1);   // cut off blank match at the end

      const lines = text.split('\n');
      const heads = headers ?? match(lines.shift());

      let filteredLines = lines.filter(function (el) {
        return el != '';
      });


      return filteredLines.map(line => {
          return match(line).reduce((acc, cur, i) => {
            // Attempt to parse as a number; replace blank matches with `null`
            const val = cur.length <= 0 ? null : Number(cur) || cur;
            const key = heads[i] ?? `extra_${i}`;
            return { ...acc, [key]: val };
          }, {});
      });
    }
  }
}
</script>
<style>
  #orderform .col {
    padding: 5px!important;
  }

.v-data-table table tfoot th
{
	position: sticky;
	bottom: 0;
	background: #FFF;
}

</style>